<template>
	<Loading :loading="loading" class="">
		<!-- Preferences Form -->
		<div class="col-12 col-md-8">
			<h2>Preferences</h2>
			<form v-if="preferences" v-on:submit.prevent="submitPreferencesForm">
				<div class="form-group row">
					<div v-for="pref of prefOptions" :key="pref.id" class="col-12 col-lg-6">
						<label class="form-check-label">
							<input 
								v-model="vModelPrefs[pref.id-1]"
								type="checkbox"
								class="preferences-check-input"
							>
							<span v-if="pref.name == 'Home Decor'">Home D{{'&eacute;'}}cor</span>
							<span v-else>{{pref.name}}</span>
						</label>  
					</div>
				</div>
				<div class="row justify-content-center">
					<ButtonWithLoading
						type="submit"
						class="btn btn-primary"
						text="Save Preferences"
						loadingText="Saving Preferences"
						successText="Updated Preferences"
						failureText="Error updating Preferences"
						:state="preferencesSubmitState"
					/>
				</div>
			</form>
		</div>
	</Loading>
</template>

<script>

import { fetchUserDetails, savePreferences, fetchPreferenceOptions  } from "@/network/userRequests";
import Loading from "@/components/loading/Loading";
import ButtonWithLoading from "@/components/buttonWithLoading";

export default {
	name: 'Preferences',
	components: {
		Loading,
		ButtonWithLoading
	},
	data: () => {
		return {
			user: null,
			preferencesSubmitState: null,
			prefOptions: null,
			loading: false,
			vModelPrefs: null,
		};
	},
	created() {
		this.getData();
	},
	methods: {
		getData() {
			this.loading = true;
			fetchUserDetails(userDetails => {
				this.user = userDetails;
				//check if billing and delivery address are the same
				// Extract the check state of the preferences for use with Vmodel
				this.vModelPrefs = []
				for (let pref of this.user.preferences) {
					if (pref != undefined) {
						this.vModelPrefs[parseInt(pref.preference_id_fk) - 1] = pref.selected
					}
				}
				fetchPreferenceOptions(  // Means the global list always shows regardless of whether the user has the most up to date one
					(prefs) => {
						this.loading = false;
						this.prefOptions = prefs;
						for (let pref of prefs) {
							if (this.vModelPrefs[parseInt(pref.id) - 1] == undefined) {
								this.vModelPrefs[parseInt(pref.id) - 1] = false;
							}
						}
					}
				)
			});
		},
		submitPreferencesForm() {
			this.preferencesSubmitState = "loading";
			let preferences = []
			for (let pref of this.prefOptions) {
				let temp = {};
				temp.preferences_id_fk = pref.id
				temp.selected = this.vModelPrefs[parseInt(pref.id) - 1]
				preferences.push(temp)
			}
			savePreferences(
				{ preferences: preferences},
				(response) => {
					if(response.success) {
						this.preferencesSubmitState = "success";
						setTimeout(() => {
							this.preferencesSubmitState = null;
						}, 1000);
					} else {
						this.preferencesSubmitState = "failure";
						setTimeout(() => {
						this.preferencesSubmitState = null;
						}, 1000);
					}
				},
				() => {
					this.preferencesSubmitState = "failure";
					setTimeout(() => {
						this.preferencesSubmitState = null;
					}, 1000);
				}
			)
		},
	},
	computed: {
		preferences() {
			if(this.user && this.user.preferences) {
				return this.user.preferences;
			}
			return null;
		},
	}
}
</script>

<style lang="scss" scoped>
	.preferences-check-input {
		position: static;
		margin-top: 0;
		margin-right: 0.3125rem;
		margin-left: 0;
	}
</style>
